export class MerchantCatalog {
  constructor(
    public locationIds: string[] = [],
    public name: string = null
  ) {
  }
}
